// extracted by mini-css-extract-plugin
export var content = "index-module--content--PfCVq";
export var contentContainer = "index-module--contentContainer--YVK93";
export var getInTouchContainer = "index-module--getInTouchContainer--Yv5eB";
export var imageContainer = "index-module--imageContainer--SDm9J";
export var page404Title = "index-module--page404-title--1Mc-1";